module.exports = {



}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js